import React from 'react';

import "./ProgressBar.css"


function ProgressBar({ done }) {

  return (
    <div className="progress">
      <div className="progress-done" style={{
        width: `${done}%`,
        opacity: 1,
      }}>
        <div className="progress-pin">{done}%</div>
      </div>
    </div>
  );
}

export default ProgressBar;